import { render, staticRenderFns } from "./EmptyContact.vue?vue&type=template&id=24865c26&scoped=true&"
var script = {}
import style0 from "./EmptyContact.vue?vue&type=style&index=0&id=24865c26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24865c26",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol})
